import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import EyeButton from '../../../components/eye-button/EyeButton';
import { toggleDedicatedTables } from '../../../redux/sonar/sonarReducer';

import scss from './SonarDashboardHeader.module.scss';

const SonarDataTableSwitch = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('header');

  const isShowDedicated = useSelector((state) => state.sonarDashboard.isShowDedicated);

  const toggleTable = useCallback(() => {
    dispatch(toggleDedicatedTables());
  }, [dispatch]);

  return (
    <div className={scss['data-table-switch-area']}>
      <span className={scss['table-switch-label']}>{t('slimTables')}</span>
      <EyeButton onClick={toggleTable} isActive={isShowDedicated} />
    </div>
  );
};

export default memo(SonarDataTableSwitch);
